import React, { createContext, useState } from 'react';

const AirwayContext = createContext(null);

function AirwayContextProvider(props) {
  const [airway, setAirway] = useState(null);

  return (
    <AirwayContext.Provider
      value={{
        airway: airway || JSON.parse(localStorage.getItem('current_airway')),
        setAirway: setAirway,
      }}
    >
      {props.children}
    </AirwayContext.Provider>
  );
}

export { AirwayContextProvider, AirwayContext as airwayContext };
